<template>
  <div v-loading="imgloading" class="img">
    <div class="select-img">选择图片</div>
    <div class="drop-out" @click="out">
      <img alt="" :src="g_imgSrc.delete" class="out" @click="out" />
    </div>
    <!-- <div class="img-material">素材库</div>
    <el-alert title="上传文件大小不能超过1M" type="info"> </el-alert> -->
    <div style="overflow: hidden">
      <tagSelect v-if="type === 'public'" class="tag-select" @emitAddPublic="emitAddPublic" />
      <tagSelectAgent v-if="type === 'app'" class="tag-select" @emitAddPublic="emitAddPublic" />
      <div class="img-updata">
        <div class="updata" @click="uploadImg">上传图片</div>
        <!-- <label for="viewfile" class="updata">上传图片</label> -->
        <!-- <input
          @input="uploadImg"
          type="file"
          id="viewfile"
          name="viewfile"
          accept=".png,.jpg"
          class="viewfile"
          style="display: none"
        /> -->
      </div>
    </div>
    <div v-if="datalist.length > 0" class="img-list">
      <div :key="data.id" class="box" v-for="(data, index) in datalist" :v-model="Imglist">
        <span
          class="button-select"
          :class="{ isSelect: data.select }"
          @click="changeSelect(data, index)"
        />
        <!-- <img
          alt=""
          v-if="!data.select"
          :src="g_imgSrc.webUnSelected"
          class="item-select cursor"
          @click="changeSelect(data)"
        />
        <img
          alt=""
          v-else
          :src="g_imgSrc.webSelected"
          class="item-select cursor"
          @click="changeSelect(data)"
        /> -->
        <el-popover
          placement="right"
          :title="type === 'public' ? '适用公众号' : '适用企业应用'"
          width="110"
          trigger="hover"
          popper-class="popverClass"
        >
          <template v-if="type === 'public'">
            <div v-for="it in data.apps" :key="it.app_id">
              {{ it.app_name }}
            </div>
          </template>
          <template v-if="type === 'app'">
            <div v-for="it in data.agents" :key="it.agent_id">
              {{ it.agent_name }}
            </div>
          </template>
          <div slot="reference" class="music-box" :class="{ isSelect: data.select }">
            <img alt="" :src="data.mate_data" class="music-box-img" />
          </div>
        </el-popover>
        <div class="name">
          {{ data.mate_name }}
        </div>
        <!-- <div class="music-box">{{data.music}}</div> -->
      </div>
    </div>
    <div v-if="datalist.length === 0" class="noDatalist">
      <img alt="" :src="g_imgSrc.bgWhite" class="noDatalist-img" />
      <div class="release-list-noData-word">暂无相关内容</div>
    </div>
    <el-pagination
      v-if="datalist.length > 0"
      class="pagination"
      style="background-color: #ffffff"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      @current-change="handleCurrentChange"
    />
    <div slot="footer" class="dialog-footer" v-if="datalist.length > 0">
      <el-button class="closeCancel" @click="out">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { EyaoSaaSSelectMaterialApi } from '@/api/releaseManagement';
import tagSelect from './tagSelect';
import tagSelectAgent from '@/components/tagSelectAgent';
export default {
  components: { tagSelect, tagSelectAgent },
  props: {
    type: {
      type: String,
      default: 'public',
    },
    selectImgclose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      total: 1, // 总条数
      size: 18, // 每页数量
      currentPage: 1, // 页数
      imgloading: false, // loading
      datalist: [], // 获取图片数组
      sortList: [], // 勾选为true的数组
      Imglist: '', // 图片列表
      file_type: 1,
      publicIds: [],
      agentIds: [],
    };
  },
  mounted() {
    this.getTaleData();
  },
  methods: {
    emitAddPublic(list) {
      if (this.type === 'public') {
        this.publicIds = list.map((item) => item.value);
      } else if (this.type === 'app') {
        this.agentIds = list.map((item) => item.value);
      }
      this.getTaleData(1);
    },
    // 图片选择
    changeSelect(i, index) {
      this.datalist = this.datalist.map((item, itemIndex) => {
        const obj = item;
        if (itemIndex === index && obj.pic_net_url === i.pic_net_url) {
          obj.select = true;
        } else {
          obj.select = false;
        }
        return obj;
      });
      this.sortList = this.datalist.filter((item) => item.select === true);
    },
    // 查询素材库列表
    async getTaleData(
      page,
      oriquery = {
        page: this.currentPage,
        limit: this.size,
        file_type: this.file_type,
        public_ids: this.publicIds,
      },
    ) {
      const query = oriquery;
      this.imgloading = true;
      if (page) {
        query.page = page;
        this.setCurrentPage = 1;
        this.sortList = [];
      }
      let mode = 1;
      if (this.type === 'public') {
        mode = 1;
      } else if (this.type === 'app') {
        mode = 2;
      }
      const res = await EyaoSaaSSelectMaterialApi({
        page_index: query.page,
        page_size: query.limit,
        mate_type: query.file_type, // 图片（image）、语音（voice）、视频（video）
        appids: this.publicIds,
        agent_ids: this.agentIds,
        mode,
      });
      for (let i = 0; i < res.mate_list.length; i++) {
        const e = res.mate_list[i];
        e.select = false;
        e.cos_file_url = window.cos_url + e.cos_url;
        e.operator_name = e.title;
      }
      this.datalist = res.mate_list;
      this.total = res.total;
      if (this.sortList.length > 0) {
        this.datalist.map((item) => {
          const obj = item;
          this.sortList.forEach((sortItem) => {
            if (sortItem.id === item.id) {
              obj.select = true;
            }
          });
          return item;
        });
      }

      this.imgloading = false;
    },
    // 上传图片
    async uploadImg() {
      this.g_tourl(`/saas/materialManagement/material-img-upload.html`, {
        open: true,
      });
    },
    // 确定上传
    confirm() {
      this.selectImgclose();
      this.$emit('selectimgDatalist', this.sortList);
    },
    // 页面改变事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTaleData();
    },
    out() {
      this.sortList = [];
      this.selectImgclose();
    },
  },
};
</script>
<style scoped lang="scss">
.img {
  .tag-select {
    width: 80%;
    float: left;
    margin: 22px 0 0 20px;
  }
  .select-img {
    font-size: 16px;
    margin-left: 24px;
  }
  .drop-out {
    height: 18px;
    width: 20px;
    position: absolute;
    top: 30px;
    right: 44px;
    cursor: pointer;
    .out {
      width: 100%;
      cursor: pointer;
    }
  }
  .img-material {
    margin-top: 25px;
    width: 796px;
    height: 40px;
    border-bottom: 1px solid #e0e1e2;
    font-size: 16px;
    margin-left: 24px;
    color: #2f96ff;
  }
  .img-updata {
    width: 99px;
    height: 40px;
    margin: 34px 20px 0 0;
    font-size: 19px;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    float: right;
    .updata {
      cursor: pointer;
      width: 99px;
      height: 40px;
      border-radius: 8px;
      font-size: 16px;
      background: #f5f7fa;
      border: 1px solid #dcdfe6;
      position: absolute;
      top: 0;
      left: 0;
    }
    .updata:hover {
      background: #e9eaeb;
      color: #ffffff;
    }
    .viewfile {
      width: 120px;
      height: 40px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .img-list {
    margin: 30px -20px 0 20px;
    .box {
      position: relative;
      display: inline-block;
      margin-right: 16px;
      // box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 24px;
      width: 137px;
      .name {
        height: 14px;
        font-size: 14px;
        color: #303133;
        margin-top: 20px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .button-select {
        position: absolute;
        background: rgba(48, 49, 51, 0.1);
        border: 1px solid #c0c4cc;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        right: 10px;
        top: 10px;
        z-index: 9;
        cursor: pointer;
        &.isSelect {
          background: #2f96ff;
          border: 1px solid #ffffff;
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            position: absolute;
            left: 50%;
            top: 50%;
            border-radius: 50%;
            margin: -4px 0 0 -4px;
            background: #ffffff;
          }
        }
      }
      .item-select {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 14px;
        left: 13px;
        font-size: 16px;
        cursor: pointer;
      }
      .title {
        width: 140px;
        height: 20px;
        position: absolute;
        top: 12px;
        left: 50px;
        font-size: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .time {
        width: 80px;
        height: 20px;
        position: absolute;
        bottom: 20px;
        left: 13px;
        font-size: 16px;
      }
      .music-box {
        width: 137px;
        height: 137px;
        position: relative;
        &.isSelect {
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: rgba(47, 150, 255, 0.15);
            border: 2px solid #2f96ff;
            border-radius: 4px;
          }
        }
        .music-box-img {
          height: 100%;
          object-fit: cover;
          width: 100%;
          border-radius: 4px;
        }
      }
    }
    // .box:hover {
    // border: 2px solid #2F96FF;;
    // }
  }

  .noDatalist {
    width: 100%;
    text-align: center;
    .noDatalist-img {
      width: 240px;
      height: 192px;
      margin-top: 10vh;
    }
  }
  .dialog-footer {
    text-align: center;
    margin-top: 20px;
    .closeCancel {
      border: 1px solid #dcdfe6;
      background: #ffffff;
      color: #606266;
    }
    .closeCancel:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #606266;
    }
  }
  .dialog-footer ::v-deep .el-button span {
    font-weight: normal;
  }
  .pagination {
    text-align: right;
    margin: 0 20px 0 0;
  }
  .pagination ::v-deep .el-pager li.number {
    color: #606266;
  }
  .pagination ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }
  .pagination ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
  .el-dialog__header {
    padding: 0px;
  }
}
.el-button--primary:hover {
  background: #63b0ff;
  color: #ffffff;
}
</style>
